import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgFilter = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="m1.581 1.224-.11.005C.69 1.31.292 2.254.822 2.874l8.56 9.996v7.348a1 1 0 0 0 .557.896l4.4 2.173.106.045a1 1 0 0 0 1.337-.942v-9.52l8.56-9.996a1 1 0 0 0-.76-1.65h-22Zm19.827 2-7.387 8.627-.084.114a1 1 0 0 0-.156.536v8.28l-2.4-1.186v-7.094l-.01-.142a1 1 0 0 0-.23-.508L3.753 3.223h17.655Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgFilter)
const Memo = memo(ForwardRef)
export default Memo
